// Utilities
import getItemTrigger from '../get-item-trigger';
import getItemAction from '../get-item-action';

/**
 * Returns information about a specific item using the item code. This won't return the item inside the recipe.
 * This returns global information
 *
 * @param {String} integrationCode The integration code. E.g. `WP`
 * @param {String} itemType The item type. E.g. `trigger`
 * @param {String} itemCode The item code. E.g. `VIEWPOST`
 * @return {Object|undefined} The item
 */
const getItem = ( integrationCode, itemType, itemCode ) => {
	// Make sure we have all the required parameters
	if ( ! integrationCode || ! itemType || ! itemCode ) {
		return;
	}

	if ( itemType === 'trigger' ) {
		return getItemTrigger( integrationCode, itemCode );
	}

	if ( itemType === 'action' ) {
		return getItemAction( integrationCode, itemCode );
	}
}

export default getItem;
